import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmarDialogComponent } from './confirmar-dialog.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [ConfirmarDialogComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule.forChild({ isolate: false })],
  exports: [ConfirmarDialogComponent]
})
export class ConfirmarDialogModule {}
